import { RootState } from "@/store/store";
import { resourceDetailsResourceCoverageDataSelector } from "@/store/resource-details/selectors/coverage-data/resourceDetailsResourceCoverageDataSelector";

export const resourceDetailsResourceCoverageDataCoveragePercentSelector = (
  state: RootState,
) => {
  const data = resourceDetailsResourceCoverageDataSelector(state);

  return data?.coverage?.total?.percentage;
};
